/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hc_Domains_NoteInputs */

const en_hc_domains_note = /** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note: To keep costs sustainable for all users, we enforce a $15.00 limit on free domain claims. Premium domains over this price are filtered out of search results.`)
};

const es_hc_domains_note = /** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota: Para mantener los costos sostenibles, aplicamos un límite de $15.00 en reclamaciones de dominios gratuitos. Los dominios premium se filtran de los resultados de búsqueda.`)
};

const fr_hc_domains_note = /** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remarque : Pour maintenir des coûts viables pour tous les utilisateurs, nous appliquons une limite de 15,00 $ sur les réclamations de domaines gratuits. Les domaines premium dépassant ce prix sont filtrés des résultats de recherche.`)
};

const de_hc_domains_note = /** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis: Um die Kosten nachhaltig zu halten, gilt ein Limit von 15,00 $ für kostenlose Domain-Ansprüche. Premium-Domains über diesem Preis werden aus den Suchergebnissen herausgefiltert.`)
};

/** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */
const ja_hc_domains_note = en_hc_domains_note;

/** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */
const zh_hc_domains_note = en_hc_domains_note;

/** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */
const ar_hc_domains_note = en_hc_domains_note;

/** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */
const id_hc_domains_note = en_hc_domains_note;

/** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */
const it_hc_domains_note = en_hc_domains_note;

/** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */
const ru_hc_domains_note = en_hc_domains_note;

/** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */
const pt_hc_domains_note = en_hc_domains_note;

/** @type {(inputs: Hc_Domains_NoteInputs) => LocalizedString} */
const ko_hc_domains_note = en_hc_domains_note;

/**
* | output |
* | --- |
* | "Note: To keep costs sustainable for all users, we enforce a $15.00 limit on free domain claims. Premium domains over this price are filtered out of search re..." |
*
* @param {Hc_Domains_NoteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const hc_domains_note = /** @type {((inputs?: Hc_Domains_NoteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hc_Domains_NoteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hc_domains_note(inputs)
	if (locale === "es") return es_hc_domains_note(inputs)
	if (locale === "fr") return fr_hc_domains_note(inputs)
	if (locale === "de") return de_hc_domains_note(inputs)
	if (locale === "ja") return ja_hc_domains_note(inputs)
	if (locale === "zh") return zh_hc_domains_note(inputs)
	if (locale === "ar") return ar_hc_domains_note(inputs)
	if (locale === "id") return id_hc_domains_note(inputs)
	if (locale === "it") return it_hc_domains_note(inputs)
	if (locale === "ru") return ru_hc_domains_note(inputs)
	if (locale === "pt") return pt_hc_domains_note(inputs)
	return ko_hc_domains_note(inputs)
});